import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ThumbsUpIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.00206 4C6.6619 5.02048 4.0079 6.47486 1.99083 6.88718C1.45054 6.99762 1.00071 7.44518 1.00059 7.99664L1.0003 8.88762C0.999992 9.71846 0.999718 10.4545 1.00057 11.2519C1.00116 11.8037 1.45126 12.2916 1.96219 12.5C2.21214 12.6019 2.48656 12.7282 2.7858 12.8658C3.13266 13.0254 3.51303 13.2556 3.92734 13.5065C5.0388 14.1793 6.39448 15 8.00251 15H11.6706C12.1518 15 12.5648 14.6573 12.6535 14.1843C12.7285 13.9724 12.5714 13.75 12.3466 13.75H10.3731C10.166 13.75 9.99813 13.5821 9.99813 13.375C9.99813 13.1679 10.166 13 10.3731 13H12.6313C12.896 13 13.132 12.8332 13.2204 12.5837C13.3645 12.1769 13.0628 11.75 12.6313 11.75H11.3731C11.166 11.75 10.9981 11.5821 10.9981 11.375C10.9981 11.1679 11.166 11 11.3731 11H12.498C12.5266 11 12.9559 10.9942 13.3481 10.9921C13.681 10.9904 14.0545 10.6876 14.1137 10.36C14.1712 10.0423 13.927 9.75 13.6041 9.75H12.3731C12.166 9.75 11.9981 9.58211 11.9981 9.375C11.9981 9.16789 12.166 9 12.3731 9H13.6242C14.1429 9 14.6053 8.67321 14.7785 8.18429C14.8939 7.56887 14.4218 7 13.7956 7H11.0025L10.9969 7.00002H10.0021C9.44978 7.00002 9.00207 6.5528 9.00207 6.00051V3C9.00207 1.80001 8.50206 1.00002 7.50206 1C6.92092 1 6.98145 1.6079 7.05562 2.35267C7.10907 2.88947 7.1696 3.49737 7.00206 4Z"
		/>
	</svg>
))
